import React, { useState, useEffect, Fragment, useContext } from "react";
import { useHistory } from "react-router-dom";
import { NavHashLink as NavLink } from "react-router-hash-link";
import Media from "react-media";
import { logo_icon, logo_text, menu_background } from "../assets/images/index";
import { LanguageContext } from "../containers/LanguageContext";
import Loader from "../components/Loader";

const NavBar = ({ fixture }) => {
  const [menu, handleMenu] = useState("close");
  const [openLang, setOpenLang] = useState(false);
  const [scroll, setScroll] = useState(0);
  const [loading, setLoading] = useState(false);
  const { state, dispatch } = useContext(LanguageContext);
  const menuClasses =
    menu === "open"
      ? "navbar--container menu--open"
      : "navbar--container menu--close";
  const location = useHistory();
  useEffect(() => {
    //analytics to location
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scroll]);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  const handleMenuOpen = (closeMenu) => {
    closeMenu && handleMenu("close");
  };
  const callLoader = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      location.push("/");
    }, 2000);
  };
  const changeLang = (language) => {
    setOpenLang(!openLang);
    if (state.lang !== language) {
      state.lang === "ES" ? dispatch({ type: "EN" }) : dispatch({ type: "ES" });
      callLoader();
    }
  };
  const navbarClasses =
    scroll >= 250 ? "navbar--fixed shadow " : "navbar--fixed ";
  return (
    <Fragment>
      {loading ? (
        <Loader msg={state.lang === "ES" ? "Traduciendo" : "Translating"} />
      ) : (
        <div className={navbarClasses}>
          <nav className={menuClasses}>
            <button
              className="menu--toggle mobile"
              onClick={() =>
                menu === "close" ? handleMenu("open") : handleMenu("close")
              }
            ></button>
            <div className="menu--inner">
              <div
                className="logo--container"
                onClick={() => {
                  location.push("/");
                }}
              >
                <img
                  title="Ceminpet Logo"
                  src={logo_icon}
                  alt="Ceminpet logo"
                  loading="lazy"
                />
              </div>
              <Media query={{ maxWidth: 768 }}>
                {(matches) =>
                  matches ? (
                    <div className="menu--container boxes">
                      <ul className="animated">
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                      </ul>
                      <div className="menu--background"></div>
                      <ul className="menu--content">
                        {fixture.options.map((item, i) => {
                          return (
                            <Fragment key={"navOption_" + i}>
                              <li>
                                {item.hash ? (
                                  <NavLink
                                    exact
                                    to={`/${item.hash}`}
                                    smooth
                                    onClick={() => handleMenuOpen(true)}
                                    isActive={(_, location) =>
                                      location.hash === item.hash
                                    }
                                  >
                                    {item.name}
                                  </NavLink>
                                ) : (
                                  <NavLink
                                    to={item.link}
                                    onClick={() => {
                                      handleMenuOpen(true);
                                    }}
                                    isActive={(_, location) =>
                                      location.pathname === item.link &&
                                      location.hash === ""
                                    }
                                    exact={i === 0 ? true : false}
                                  >
                                    {item.name}
                                  </NavLink>
                                )}
                              </li>
                            </Fragment>
                          );
                        })}
                      </ul>
                    </div>
                  ) : (
                    <Fragment>
                      <ul className="menu--navbar">
                        {fixture.options.map((item, i) => {
                          return (
                            <Fragment key={"navOption_" + i}>
                              <li>
                                {item.hash ? (
                                  <NavLink
                                    exact
                                    to={`/${item.hash}`}
                                    smooth
                                    onClick={() => handleMenuOpen(true)}
                                    isActive={(_, location) =>
                                      location.hash === item.hash
                                    }
                                  >
                                    {item.name}
                                  </NavLink>
                                ) : (
                                  <NavLink
                                    to={item.link}
                                    onClick={() => {
                                      handleMenuOpen(true);
                                    }}
                                    isActive={(_, location) =>
                                      location.pathname === item.link &&
                                      location.hash === ""
                                    }
                                    exact={i === 0 ? true : false}
                                  >
                                    {item.name}
                                  </NavLink>
                                )}
                              </li>
                            </Fragment>
                          );
                        })}
                      </ul>
                    </Fragment>
                  )
                }
              </Media>
              <div className="menu--rightside">
                <img
                  title="Ceminpet Logo text"
                  className="logo--text"
                  src={logo_text}
                  alt="Ceminpet text"
                  loading="lazy"
                />
                <div className={`chooseLang ${openLang ? "open" : ""}`}>
                  <div>
                    <span
                      id="es-lang"
                      className={`lang es-lang ${
                        state.lang === "ES" ? "chosen" : ""
                      }`}
                      onClick={() => changeLang("ES")}
                    ></span>
                    <span
                      id="en-lang"
                      className={`lang en-lang ${
                        state.lang === "EN" ? "chosen" : ""
                      }`}
                      onClick={() => changeLang("EN")}
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </div>
      )}

      <style jsx>
        {`
          .chooseLang {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            height: 30px;
          }
          .chooseLang div {
            height: 30px;
            position: relative;
            width: 72px;
          }
          .lang {
            cursor: pointer;
            display: block;
            height: 30px;
            position: absolute;
            opacity: 0;
            left: 42px;
            top: 0;
            -webkit-transition: 0.76s;
            -o-transition: 0.76s;
            transition: 0.76s;
            width: 30px;
          }
          .en-lang {
            background-image: url(data:image/svg+xml;base64,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);
          }
          .open .en-lang {
            left: 5px;
            opacity: 1;
          }
          .es-lang {
            background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/PjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHBhdGggc3R5bGU9ImZpbGw6I0ZGREE0NDsiIGQ9Ik0wLDI1NmMwLDMxLjMxNCw1LjYzMyw2MS4zMSwxNS45MjMsODkuMDQzTDI1NiwzNjcuMzA0bDI0MC4wNzctMjIuMjYxQzUwNi4zNjcsMzE3LjMxLDUxMiwyODcuMzE0LDUxMiwyNTZzLTUuNjMzLTYxLjMxLTE1LjkyMy04OS4wNDNMMjU2LDE0NC42OTZMMTUuOTIzLDE2Ni45NTdDNS42MzMsMTk0LjY5LDAsMjI0LjY4NiwwLDI1NnoiLz48Zz48cGF0aCBzdHlsZT0iZmlsbDojRDgwMDI3OyIgZD0iTTQ5Ni4wNzcsMTY2Ljk1N0M0NTkuOTA2LDY5LjQ3MywzNjYuMDcxLDAsMjU2LDBTNTIuMDk0LDY5LjQ3MywxNS45MjMsMTY2Ljk1N0g0OTYuMDc3eiIvPjxwYXRoIHN0eWxlPSJmaWxsOiNEODAwMjc7IiBkPSJNMTUuOTIzLDM0NS4wNDNDNTIuMDk0LDQ0Mi41MjcsMTQ1LjkyOSw1MTIsMjU2LDUxMnMyMDMuOTA2LTY5LjQ3MywyNDAuMDc3LTE2Ni45NTdIMTUuOTIzeiIvPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48Zz48L2c+PGc+PC9nPjxnPjwvZz48L3N2Zz4=);
          }
          .open .es-lang {
            opacity: 1;
          }
          .chooseLang .chosen {
            opacity: 1;
            z-index: 1;
          }
          .navbar--fixed {
            position: relative;
            z-index: 3;
            top: 0;
            width: 100%;
            background-color: transparent;
            transition: background-color 0.5s ease;
          }
          .menu--navbar {
            display: flex;
            box-sizing: border-box;
            padding: 0;
            margin: 0;
            align-self: center;
            flex-grow: 1;
            padding-bottom: 3px;
            justify-content: space-evenly;
            max-width: 700px;
          }
          .menu--navbar li {
            display: inline-block;
            list-style: outside none none;
            margin: 0 1.5em;
            padding: 0;
          }
          .menu--navbar li :global(a) {
            text-decoration: none;
            position: relative;
            color: #2e1e56;
            padding-bottom: 3px;
          }
          .menu--navbar li :global(a:before),
          .menu--navbar li :global(a:after) {
            position: absolute;
            -webkit-transition: all 0.35s ease;
            transition: all 0.35s ease;
          }
          .menu--navbar li :global(a:before) {
            bottom: 0;
            display: block;
            height: 2px;
            width: 0%;
            content: "";
            background-color: #0197a9;
          }
          .menu--navbar li :global(a:hover:before),
          .menu--navbar li :global(a.active:before) {
            width: 100%;
          }
          .menu--navbar li :global(a:focus) {
            outline: none;
          }
          .navbar--container {
            display: flex;
            padding: 10px 20px;
          }
          .menu--toggle {
            background-color: transparent;
            position: fixed;
            top: 30px;
            left: 20px;
            border: none;
            z-index: 4;
            padding: 0;
            cursor: pointer;
          }
          .menu--rightside .logo--text {
            width: 200px;
            object-fit: contain;
          }
          .menu--toggle:before,
          .menu--toggle:after {
            display: block;
            content: "";
            background: #212121;
            width: 30px;
            height: 3px;
          }
          .menu--toggle:before {
            margin-bottom: 6px;
            transition: transform 0.3s ease;
          }
          .menu--toggle:after {
            margin-top: 6px;
            transition: transform 0.3s ease;
          }
          .menu--toggle:hover:before {
            transform: translateY(-2px);
            transition: all 0.3s ease;
          }
          .menu--toggle:hover:after {
            transform: translateY(2px);
            transition: all 0.3s ease;
          }
          .menu--toggle:active,
          .menu--toggle:focus {
            outline: none;
          }
          .logo--container img {
            object-fit: contain;
            width: 65px;
            cursor: pointer;
          }
          .menu--inner {
            display: flex;
            flex-grow: 1;
            justify-content: space-between;
            flex-direction: row;
          }
          .navbar--container.menu--open .menu--toggle:before {
            margin: 0;
            transform: translateY(-3px) rotate(45deg);
          }
          .navbar--container.menu--open .menu--toggle:after {
            margin: 0;
            transform: translateY(-5px) rotate(-45deg);
          }
          .navbar--container.menu--open .menu--container {
            height: 100vh;
            transition: height 0.5s ease;
          }
          .navbar--container.menu--open .menu--toggle:before,
          .navbar--container.menu--open .menu--toggle:after {
            background-color: #bdbdbd;
            height: 3px;
          }
          .menu--container {
            top: 0;
            left: 0;
            position: fixed;
            width: 100%;
            height: 0px;
            margin: 0;
            z-index: 3;
            overflow: hidden;
            padding: 0;
            transition: height 0.5s ease;
            background-color: #7a8286;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }
          .menu--background {
            position: absolute;
            background-image: url(${menu_background});
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center center;
            opacity: 0.4;
          }
          .menu--content {
            padding: 0;
          }

          .menu--content li {
            list-style: none;
            width: 100%;
            text-align: center;
            cursor: pointer;
            margin: 25px 0;
          }

          .menu--content li :global(a) {
            text-decoration: none;
            font-size: 35px;
            text-transform: uppercase;
            color: #fafafa;
            display: inline-block;
            position: relative;
            padding: 0 10px;
          }

          .menu--content li :global(a:after) {
            content: "";
            width: 0px;
            position: absolute;
            display: flex;
            transition: width 0.4s ease;
          }
          .menu--content li :global(a.active:after),
          .menu--content li :global(a:hover:after) {
            content: "";
            height: 5px;
            width: 100%;
            background-color: #fafafa;
            transform: rotate(-3deg);
            right: 15px;
            left: 0;
            top: calc(50% - 0px);
          }
          .menu--rightside {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }

          .menu--rightside .icon--language div {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 45px;
            height: 45px;
            border-radius: 50px;
            background-color: #ffffffad;
            border: 1px solid transparent;
            opacity: 0.6;
            font-size: 12px;
            font-weight: bold;
            cursor: pointer;
            margin-left: 10px;
          }
          .menu--rightside .icon--language {
            display: flex;
            flex-direction: column;
          }
          .menu--rightside .icon--language div.flip--vertical span {
            transform: rotateX(180deg);
          }
          .menu--rightside .icon--language div.flip--vertical {
            position: absolute;
            visibility: hidden;
            transform: translateY(35px) rotateX(90deg);
            transition: all 0.5s linear;
            border-radius: 50px;
            background-color: #e0e0e0;
            border: 1px solid #212121;
            opacity: 0.6;
          }
          .menu--rightside .icon--language div.flip--vertical:hover {
            background-color: #ffffffad;
            border: 1px solid transparent;
          }
          .menu--rightside .icon--language:hover div.flip--vertical {
            visibility: visible;
            transform: translateY(49px) rotateX(180deg);
            transform-style: preserve-3d;
            transition: all 0.5s ease;
          }
          .navbar--fixed.shadow {
            background-color: #ffffffe0;
            transition: all 0.5s ease;
            box-shadow: -1px -2px 17px black;
          }
          ul.animated {
            list-style-type: none;
            width: 100%;
            position: absolute;
            bottom: 0;
            margin: 0;
          }
          .animated li:nth-child(1) {
            position: absolute;
            left: 10%;
            height: 30px;
            width: 30px;
            animation-delay: 0s;
          }
          .animated li:nth-child(2) {
            position: absolute;
            left: 30%;
            height: 45px;
            width: 45px;
            animation-delay: 1.5s;
            animation-duration: 10s;
          }
          .animated li:nth-child(3) {
            position: absolute;
            left: 50%;
            height: 70px;
            width: 70px;
            opacity: 0;
            animation-delay: 5.5s;
          }
          .animated li:nth-child(4) {
            position: absolute;
            left: 80%;
            height: 20px;
            width: 20px;
            animation-delay: 0s;
            animation-duration: 15s;
          }
          .animated li:nth-child(5) {
            position: absolute;
            left: 65%;
            height: 45px;
            width: 45px;
            animation-delay: 0s;
          }
          .animated li:nth-child(6) {
            position: absolute;
            left: 30%;
            height: 45px;
            width: 45px;
            animation-delay: 3.5s;
            opacity: 0;
          }
          .animated li {
            animation: animate 20s linear 1s infinite;
            background: rgba(255, 255, 255, 0.2);
          }

          @keyframes animate {
            0% {
              transform: translateY(0) rotate(0deg);
              opacity: 1;
            }
            100% {
              transform: translateY(-800px) rotate(360deg);
              opacity: 0;
            }
          }
          @media screen and (max-width: 768px) {
            .navbar--fixed {
              position: fixed;
              width: 100vw;
            }
            .menu--toggle {
              position: unset;
            }
            .menu--inner {
              padding-left: 30px;
            }
          }
          @media screen and (max-width: 425px) {
            .navbar--container {
              padding-right: 10px;
            }
            .logo--container img {
              width: 50px;
            }
            .menu--inner {
              padding-left: 15px;
            }
            .menu--rightside .logo--text {
              width: 150px;
            }
            .lang {
              left: 5px;
            }
            .open .en-lang {
              top: 35px;
              opacity: 1;
            }
            .chooseLang {
              width: 40px;
            }
          }
          @media screen and (max-width: 375px) {
            .menu--content li :global(a) {
              font-size: 28px;
            }
          }
        `}
      </style>
    </Fragment>
  );
};
export default NavBar;
